import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shippingdetail',
  templateUrl: './shippingdetail.component.html',
  styleUrls: ['./shippingdetail.component.scss']
})
export class ShippingdetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
